import {IndicatorEditForm} from './components/indicator-edit-form';

export const EditIndicator = () => {
  return <IndicatorEditForm action="edit" />;
};
